<script>
    import { get_price_request } from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/get_price_request.js?1733898724646';
    import { get_stock } from '/srv/web/wyvr/html/releases/58819/gen/client/shop/core/product/get_stock.js?1733898724646';
    import AddToCart from '/srv/web/wyvr/html/releases/58819/gen/client/shop/product/AddToCart.svelte?1733898724646';
    import WhatsAppButton from '/srv/web/wyvr/html/releases/58819/gen/client/shop/whatsapp/WhatsAppButton.svelte?1733898724646';
    import PriceRequestButton from '/srv/web/wyvr/html/releases/58819/gen/client/price_request/Button.svelte?1733898724646';
    import AmazonPay from '/srv/web/wyvr/html/releases/58819/gen/client/checkout_buttons/AmazonPay.svelte?1733898724646';
    import PayPal from '/srv/web/wyvr/html/releases/58819/gen/client/checkout_buttons/PayPal.svelte?1733898724646';
    import Live from '/srv/web/wyvr/html/releases/58819/gen/client/magento2/product/live/Live.svelte?1733898724646';

    export let product;

    wyvr: {
        render: 'hydrate';
        loading: 'instant';
    }

    let price_request = false;
    let stock = null;
    let in_stock = false;

    $: update(product);

    function update(product) {
        price_request = get_price_request(product);
        stock = get_stock(product);
        in_stock = stock?.is_in_stock || false;
    }

    function live_update({ detail }) {
        if (detail?.product) {
            update(detail.product);
        }
    }
</script>

<Live {product} let:product on:update={live_update}>
    <div class="action-buttons">
        {#if price_request && in_stock}
            <PriceRequestButton {product} />
        {:else}
            <AddToCart {product} />
            {#if in_stock}
                <WhatsAppButton {product} />
            {/if}
        {/if}
    </div>

    {#if !price_request && in_stock}
        <div class="checkout-buttons">
            <AmazonPay {product} />
            <PayPal {product} />
        </div>
    {/if}
</Live>


<style>
    .action-buttons {
        display: flex;
        justify-content: space-between;
        align-items: stretch;
        gap: 10px;
        margin: 15px 0;
    }

    .action-buttons > :global(div) {
        flex: 1 1 0;
    }

    .action-buttons > :global(div > .add-to-cart-btn-wrapper) {
        height: 100%;
    }

    .action-buttons :global(.c-whatsapp-button) {
        flex: 1 1 0;
    }

    .action-buttons > :global(div > .c-whatsapp-button) {
        height: 100%;
    }

    .checkout-buttons {
        margin-top: 15px;
        margin-bottom: 15px;
    }

    .checkout-buttons > :global(*) {
        width: 100%;
        margin-bottom: 15px;
    }
    
    .checkout-buttons :global(.btn) {
        width: 100%;
        font-size: 20px;
        padding-top: 10px;
        padding-bottom: 10px;
    }
</style>